'use client';

import React from 'react';
import Image from 'next/image';
import { Button } from '../../components/ui/Button';
import WhatsappIcon from '../../icons/WhatsappIcon';
import WhatsappCTAButton from '@/components/ui/WhatsappCTAButton';

export default function Equipe() {
  return (
    <div className="min-h-screen flex flex-col items-center bg-[#FFFBF5]">
      <div className="flex flex-col items-center gap-4 mb-2 sm:mb-0 bg-[#192437] w-full p-8">
        <a href="/">
          <Image
            src="/logo-jb-primary.svg"
            alt="Escritório de advocacia John Bihuna em Biguaçu, SC"
            width={228}
            height={72}
            className="w-[228px] h-[72px]"
          />
        </a>
      </div>
      <div className="p-4 sm:p-8 sm:mt-10 w-full max-w-4xl flex flex-col gap-2">
        <h1 className="text-secondary text-2xl sm:text-4xl font-medium mb-2">Nossa equipe</h1>
        <p className="text-primary text-lg font-medium mt-4">
          <strong>
            Trabalho de forma integrada para oferecer soluções jurídicas seguras, eficientes e sob
            medida para cada cliente.
          </strong>
        </p>
        <p className="text-primary text-sm font-medium">
          Contamos com uma equipe de advogados altamente qualificados em Biguaçu/SC, com atuação estratégica e
          comprometida com a excelência jurídica. Cada profissional do nosso escritório reúne sólida
          formação acadêmica, experiência prática e especialização em diferentes áreas do Direito,
          garantindo um atendimento completo, personalizado e eficaz para pessoas físicas e
          jurídicas em Biguaçu, Florianópolis, São José e toda Santa Catarina.
        </p>
      </div>
      <div className="flex flex-col sm:flex-row gap-6 sm:mt-6 w-full sm:w-auto justify-center p-3">
        <WhatsappCTAButton />
      </div>
    </div>
  );
}
